<template>
  <div>
    <template v-if="pack.channel === 'shopee_marketing_plan'">
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Số lượng file kế hoạch
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <span style="color: red; font-weight: 600">Không giới hạn</span>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Lập kế hoạch tháng toàn shop
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Lập kế hoạch tháng theo sản phẩm
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Lập kế hoạch ads
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Lập kế hoạch theo đơn hàng
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="height: 80px"></div>
    </template>

    <template v-if="pack.channel === 'shopee_marketing_fs'">
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Số lượng file sản phẩm
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <span style="color: red; font-weight: 600">Không giới hạn</span>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Tự động tạo Flash Sale theo khung giờ
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Tự động tạo Flash Sale liên tục
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Đăng ký Flash Sale của Sàn
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="height: 110px"></div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    pack: {
      type: Object,
      required: true
    }
  },

  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/pages/package/component/atosa_advanced_component.vue